import React from 'react';
export const Footer = () => {
  return <footer id="footer" className="bg-white border-t border-gray-200 pt-16 pb-8" data-id="element-57">
      <div className="container mx-auto px-4 md:px-6" data-id="element-58">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-59">
          {/* Brand & Contact */}
          <div data-id="element-60">
            <div className="flex items-center gap-2 mb-6" data-id="element-61">
              <div className="w-8 h-8 bg-black text-white flex items-center justify-center font-display font-bold text-lg" data-id="element-62">
                R
              </div>
              <span className="font-display font-semibold text-xl tracking-tight" data-id="element-63">
                Recovery<span className="text-gray-400" data-id="element-64">Clinic</span>
              </span>
            </div>
            <div className="space-y-4" data-id="element-65">
              <div data-id="element-66">
                <div className="text-sm text-gray-500 mb-1" data-id="element-67">
                  Цілодобова лінія:
                </div>
                <a href="tel:+380000000000" className="text-xl font-bold hover:opacity-70 transition-opacity" data-id="element-68">
                  0 800 00 00 00
                </a>
              </div>
              <div data-id="element-69">
                <div className="text-sm text-gray-500 mb-1" data-id="element-70">Район виїзду:</div>
                <div className="font-medium" data-id="element-71">Київ та Київська область</div>
              </div>
              <div className="flex gap-4 pt-2" data-id="element-72">
                <a href="#" className="text-sm font-medium text-gray-600 hover:text-black underline underline-offset-4" data-id="element-73">
                  Viber
                </a>
                <a href="#" className="text-sm font-medium text-gray-600 hover:text-black underline underline-offset-4" data-id="element-74">
                  Telegram
                </a>
                <a href="#" className="text-sm font-medium text-gray-600 hover:text-black underline underline-offset-4" data-id="element-75">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Nav */}
          <div data-id="element-76">
            <h4 className="font-bold mb-6" data-id="element-77">Навігація</h4>
            <ul className="space-y-3" data-id="element-78">
              <li data-id="element-79">
                <a href="#services" className="text-gray-600 hover:text-black transition-colors" data-id="element-80">
                  Послуги
                </a>
              </li>
              <li data-id="element-81">
                <a href="#how-it-works" className="text-gray-600 hover:text-black transition-colors" data-id="element-82">
                  Як працюємо
                </a>
              </li>
              <li data-id="element-83">
                <a href="#pricing" className="text-gray-600 hover:text-black transition-colors" data-id="element-84">
                  Ціни
                </a>
              </li>
              <li data-id="element-85">
                <a href="#testimonials" className="text-gray-600 hover:text-black transition-colors" data-id="element-86">
                  Відгуки
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-87">
            <h4 className="font-bold mb-6" data-id="element-88">Послуги</h4>
            <ul className="space-y-3" data-id="element-89">
              <li data-id="element-90">
                <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-91">
                  Вивід із запою на дому
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-93">
                  Лікування в стаціонарі
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-95">
                  Кодування від алкоголізму
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="text-gray-600 hover:text-black transition-colors" data-id="element-97">
                  Підшивка
                </a>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div data-id="element-98">
            <h4 className="font-bold mb-6" data-id="element-99">Інформація</h4>
            <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-100">
              Медична ліцензія МОЗ України №123456 від 01.01.2020.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-101">
              Гарантуємо повну анонімність. Дані пацієнтів не передаються третім
              особам та державним установам.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-102">
          <div data-id="element-103">
            © {new Date().getFullYear()} Recovery Clinic. Всі права захищені.
          </div>
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-104">
            <a href="#" className="hover:text-black transition-colors" data-id="element-105">
              Політика конфіденційності
            </a>
            <span className="hidden md:inline text-gray-300" data-id="element-106">|</span>
            <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-black transition-colors" data-id="element-107">
              Сайт створено командою{' '}
              <span className="font-bold text-black" data-id="element-108">Jetly Agency</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};